module.exports = __webpack_public_path__ + "img/norway.ed7007a8.svg";